// 🧿 طلسم محافظ فایل

import React from "react";
// Common Components
import { Button, TextInput } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import { Additional } from "./RiskProfileAdditional";
// Hooks
import { useAppDispatch, useAppSelector } from "src/App/hooks";
// Services
import {
  upsertRiskProfile,
  getRiskProfileTable,
  getRiskProfileDropDown,
} from "src/Requests/coveredCall";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
import { toast } from "react-toastify";
import {
  setRiskProfile,
  setRiskProfiles,
} from "src/Features/CoveredCall/CoveredCallSlice";

const RiskProfile: React.FC = () => {
  // hooks
  const dispatch = useAppDispatch();
  //local store
  const [loading, setLoading] = React.useState<boolean>(false);
  const [refreshFlag, setRefreshFlag] = React.useState(false);
  // store
  const riskProfile = useAppSelector((store) => store.coveredCall.riskProfile);

  const clickHandler = () => {
    setLoading(true);
    upsertRiskProfile(riskProfile)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          setRefreshFlag((previous) => !previous);
          dispatch(setRiskProfile({ id: undefined, profileName: "" }));
          getRiskProfileDropDown().then((res) => {
            dispatch(setRiskProfiles([{ id: "0", name: "تجمیعی" }, ...res]));
          });
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const searchParameters = React.useMemo(() => ({}), []);

  return (
    <div className="flex flex-col justify-start items-start gap-3">
      <div className="flex gap-5 items-end w-full">
        <div className="w-64">
          <TextInput
            name="profileName"
            label="نام پروفایل ریسک"
            extraLabel
            onChange={(_, value) => {
              dispatch(setRiskProfile({ profileName: value }));
            }}
            value={riskProfile.profileName}
          />
        </div>
        <div className="w-4">
          <Button
            text="ثبت"
            onClick={clickHandler}
            variant="contained"
            className="table-btn"
            loading={loading}
          />
        </div>
      </div>
      <div className="w-full h-[1px] bg-zinc-200 my-4" />
      <TableTemplate
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            refreshFlag={refreshFlag}
            AdditionalBody={Additional}
          />
        )}
        getDataTable={getRiskProfileTable}
        searchParameters={searchParameters}
      />
    </div>
  );
};

export default RiskProfile;
